import { registerQuickJSModule } from '@natural-apptitude/coreo-expressions/dist/esm';

export const initExpressionRuntime = async (): Promise<void> => {
  const { ensureQuickJSBrowserModule } = await import(
    '@natural-apptitude/coreo-expressions/dist/esm/runtime/quickjsModule.browser.js'
  );
  registerQuickJSModule(await ensureQuickJSBrowserModule());
};
